import { render, staticRenderFns } from "./new-request-v2.modal.vue?vue&type=template&id=bd910678&scoped=true"
import script from "./new-request-v2.modal.vue?vue&type=script&lang=js"
export * from "./new-request-v2.modal.vue?vue&type=script&lang=js"
import style0 from "./new-request-v2.modal.vue?vue&type=style&index=0&id=bd910678&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd910678",
  null
  
)

export default component.exports